/*
  Hero words drift (Figma: Full Width Media, MS-014). On the homepage hero the heading,
  text and button rise a little slower than the page and fade as it scrolls away.
  Tablet and desktop only: on a phone, text drifting under a thumb reads as lag.
  Reduced motion: nothing moves. One rAF per scroll frame, transform and opacity only.
*/
(function () {
  var hero = document.querySelector('banner-hero.banner-hero--page-hero');
  if (!hero) return;
  var words = hero.querySelector('.hero-banner-txt-content__wrapper');
  if (!words) return;
  var wide = window.matchMedia('(min-width: 768px)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var queued = false;

  function paint() {
    queued = false;
    if (!wide.matches || reduced.matches) {
      words.style.transform = '';
      words.style.opacity = '';
      return;
    }
    var h = hero.offsetHeight || 1;
    var y = Math.min(Math.max(window.scrollY, 0), h);
    words.style.transform = 'translate3d(0,' + (y * -0.15).toFixed(1) + 'px,0)';
    words.style.opacity = (1 - Math.min(y / (h * 0.6), 1)).toFixed(3);
  }
  function queue() {
    if (!queued) { queued = true; requestAnimationFrame(paint); }
  }
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue);
  paint();
})();
